"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var eventemitter3_1 = require("eventemitter3");
var VidiEmitter = (function (_super) {
    __extends(VidiEmitter, _super);
    function VidiEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VidiEmitter;
}(eventemitter3_1.EventEmitter));
exports.VidiEmitter = VidiEmitter;
//# sourceMappingURL=events.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vidi/dist/src/types/events.js
// module id = 2771
// module chunks = 66